import { useCallback, useContext } from 'react';

import { Profile } from '@shared/api';

import { AppFeature, useIsFeatureEnabled } from 'src/config';
import { useSwyftxMarginStore } from 'src/lib/margin';

import { UIContext } from '../context/UI.context';

const useCurrentPlatform = () => {
  const { currentPlatform, setCurrentPlatform } = useContext(UIContext);
  const { isFeatureEnabled } = useIsFeatureEnabled();
  const { reset } = useSwyftxMarginStore();

  const checkCurrentPlatform = useCallback(
    (profile: Profile) => {
      const { proEnabled, derivativesEnabled } = profile;
      const derivativesActive = derivativesEnabled && isFeatureEnabled(AppFeature.SwyftxDerivatives);

      if (currentPlatform === 'derivatives' && !derivativesActive) {
        setCurrentPlatform('swyftx');
        reset();
      } else if (currentPlatform === 'swyftx-pro' && !proEnabled) {
        setCurrentPlatform('swyftx');
      }
    },
    [currentPlatform, isFeatureEnabled, reset, setCurrentPlatform],
  );

  return {
    currentPlatform,
    setCurrentPlatform,
    checkCurrentPlatform,
  };
};

export { useCurrentPlatform };
